#!/usr/bin/env node
import { getSimplePrice } from "./api"
import { initMessage } from "./logger"
import program from "./commander"

const { interval } = program

const main = async () => {
  initMessage()
  await getSimplePrice()
  setInterval(async () => {
    await getSimplePrice()
  }, interval)
}

main()
